import { render, staticRenderFns } from "./SpiritAbilities.vue?vue&type=template&id=440d0013&scoped=true"
import script from "./SpiritAbilities.vue?vue&type=script&lang=js"
export * from "./SpiritAbilities.vue?vue&type=script&lang=js"
import style0 from "./SpiritAbilities.vue?vue&type=style&index=0&id=440d0013&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d0013",
  null
  
)

export default component.exports